import React from 'react'
import PropTypes from 'prop-types'

// This component is just an equivalent of PopoverOnClick but that renders
// around the toolbar instead of in document.body
export default class ToolbarBottomPopover extends React.Component {
  state = { isOpen: false }

  static propTypes = {
    content: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  }

  static defaultProps = {
    content: () => {},
  }

  onIsOpenChange = isOpen => this.setState({ isOpen })

  onDropdownRef = ref => {
    // This event listener is here to prevent InlineToolbar's hiding logic when
    // cursor is dragged inside editor.
    if (ref && !this.dropdownRef) {
      this.dropdownRef = ref
      this.dropdownRef.addEventListener('mousedown', event => {
        event.stopPropagation()
        event.preventDefault()
      })
    } else if (!ref && this.dropdownRef) {
      delete this.dropdownRef
    }
  }

  render() {
    return (
      <div
        style={{ position: 'relative' }}
        onClick={() => {
          this.setState({
            isOpen: !this.state.isOpen,
          })
        }}
      >
        <div>{this.props.children}</div>
        {this.state.isOpen && (
          <div
            ref={this.onDropdownRef}
            style={{ position: 'absolute', top: 30, right: 0 }}
          >
            {this.props.content(() => this.setState({ isOpen: false }))}
          </div>
        )}
      </div>
    )
  }
}
